import s from "./ProductoImagen.module.css";

/**
 * Mientras no haya fotografia de cada producto, dibujamos su seccion
 * transversal. Es honesto (no simula una foto), pesa nada y distingue de un
 * vistazo una plancha de un eje macizo.
 *
 * Si el producto trae `imagen`, se usa esa en su lugar.
 */
export default function ProductoImagen({ producto, alto = 180 }) {
  if (producto?.imagen) {
    return (
      <img
        className={s.foto}
        src={producto.imagen}
        alt={producto.nombre}
        style={{ height: alto }}
        loading="lazy"
      />
    );
  }

  return (
    <div className={s.lienzo} style={{ height: alto }} aria-hidden="true">
      <svg viewBox="0 0 120 120" className={s.svg}>
        <defs>
          <pattern id="rejilla" width="10" height="10" patternUnits="userSpaceOnUse">
            <path d="M10 0H0v10" fill="none" stroke="currentColor" strokeWidth="0.4" opacity="0.25" />
          </pattern>
        </defs>
        <rect width="120" height="120" fill="url(#rejilla)" />
        <g
          fill="none"
          stroke="var(--color-ink)"
          strokeWidth="2"
          strokeLinejoin="round"
        >
          <Seccion producto={producto} />
        </g>
      </svg>
    </div>
  );
}

function Seccion({ producto }) {
  const cat = producto?.categoria || "";

  // Plancha vista en perspectiva, con el canto marcado en rojo
  if (cat.includes("plancha")) {
    return (
      <>
        <path d="M18 54 60 34l42 20-42 20-42-20Z" fill="var(--color-surface-2)" />
        <path d="M18 54 60 34l42 20-42 20-42-20Z" />
        <path
          d="M18 54v10l42 20v-10"
          stroke="var(--color-accent)"
          strokeWidth="2.5"
        />
        <path d="M102 54v10L60 84" />
      </>
    );
  }

  // Eje macizo: circulo relleno con la cota del diametro
  if (cat.includes("eje")) {
    return (
      <>
        <circle cx="60" cy="60" r="30" fill="var(--color-surface-2)" />
        <circle cx="60" cy="60" r="30" />
        {/* Achurado que indica material macizo */}
        <g stroke="var(--color-steel)" strokeWidth="1.2" opacity="0.55">
          <path d="M42 38 82 78M50 33 87 70M34 46 74 86M38 74 46 82M74 34 82 42" />
        </g>
        {/* Cota de diametro */}
        <path
          d="M30 60h60"
          stroke="var(--color-accent)"
          strokeWidth="2"
          strokeDasharray="4 3"
        />
        <path
          d="M34 56l-4 4 4 4M86 56l4 4-4 4"
          stroke="var(--color-accent)"
          strokeWidth="2"
          fill="none"
        />
      </>
    );
  }

  return (
    <rect x="30" y="30" width="60" height="60" rx="4" fill="var(--color-surface-2)" />
  );
}
